import ajv from 'ajv';

import { FailureSeverity } from '../types/FailureSeverity';
import { ValidationResult } from '../types/ValidationResult';

export const mapToValidationResult = (isValid: boolean, validationErrors: ajv.ErrorObject[]): ValidationResult => {
  return {
    isValid,
    failures:
      validationErrors?.map((error: ajv.ErrorObject) => {
        return {
          code: error.dataPath,
          message: error.message ?? error.keyword,
          severity: FailureSeverity.Error,
        };
      }) ?? [],
  };
};
